import { useEffect, useState } from "react";
import ModalResponse from "~components/Modal/ModalResponse";

import { PropTypes } from "prop-types";
import useParametros from "~fetchs/useParametros";

const SearchNotUpdatedModal = ({ searches, daysToExpire = 5 }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [diasSemPesquisaParametro, setDiasSemPesquisaParametro] = useState(daysToExpire);

  const { toObjectSlug, getSlug, parameterSlugs } = useParametros();

  useEffect(() => {
    if (toObjectSlug) {
      setDiasSemPesquisaParametro(getSlug(parameterSlugs.mapaMina.quantidadeDiasSemPesquisa, daysToExpire));
    }
  }, [toObjectSlug]);

  const verifyDateExpired = (dateStr) => {
    const now = new Date();

    const [day, month, year] = dateStr.split("/");
    const date = new Date(year, month - 1, day);

    const differenceInMiliseconds = now - date;

    const milisecondsInADay = 1000 * 60 * 60 * 24;
    const differenceInDays = Math.floor(differenceInMiliseconds / milisecondsInADay);

    return differenceInDays > diasSemPesquisaParametro;
  };

  useEffect(() => {
    if (searches && searches?.length > 0 && !initialized) {
      const getActivedSearchs = (searches ?? []).filter((search) => search.ativo && search.deletadoEm == null);
      const shouldOpen = getActivedSearchs.every((search) => verifyDateExpired(search.ultimaAtualizacao));
      setIsOpen(shouldOpen);
      setInitialized(true);
    }
  }, [searches]);

  return (
    <ModalResponse
      isOpen={isOpen}
      closeModal={() => {
        setIsOpen(false);
      }}
      message={"Aviso!"}
      submessage={`Não houve nenhuma alteração de dados da pesquisa desse cliente nos últimos ${diasSemPesquisaParametro} dias`}
      status={"alert"}
    />
  );
};

SearchNotUpdatedModal.propTypes = {
  searches: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      ultimaAtualizacao: PropTypes.string,
      dadosGerais: PropTypes.object,
    })
  ),
  daysToExpire: PropTypes.number,
};

export default SearchNotUpdatedModal;
